export class ErrorMsg {


    errorsCode = {
        pl:
            {
                "2.1": "Błędny login lub hasło",
                "4.34": {
                    "medicover": "Podany numer telefonu nie jest powiązany z aktywną usługą Medicover Sport",
                    "multisport": "Podany numer karty MultSport Plus nie jest poprawny",
                },
                "4.30": "Podany numer karty MultSport Plus jest zajęty",
                "4.6": "już jest zarejestrowany",
                "14.4": "Nieprawidłowe stare hasło",
                "5.3": "Posiadasz już aktywny karnet lub subskrypcję",
                "5.2": "Członkostwo nie dostępne w wybrany wariacie",
                "14.9": "Upppss, wygląda na  to że się nie znamy",
                "1.17": "Niepoprawne dane"
            },
        en:
            {
                "2.1": "Incorrect login or password",
                "4.34": {
                    "medicover": "The provided phone number is not associated with an active Medicover Sport service",
                    "multisport": "The provided MultiSport Plus card number is incorrect"
                },
                "4.30": "The provided MultiSport Plus card number is already taken.",
                "4.6": "Already registered",
                "14.4": "Invalid old password",
                "5.2": "Membership not available in the selected variant",
                "5.3": "You already have an active membership",
                "14.9": "Email address not registered",
                "1.17": "Invalid data"
            },
        uk:
            {
                "2.1": "Неправильний логін або пароль",
                "4.34": {
                    "medicover": "Наданий номер телефону не пов’язаний з активною послугою Medicover Sport",
                    "multisport": "Наданий номер картки MultiSport Plus є неправильним"
                },
                "4.30": "Вказаний номер картки MultiSport Plus вже зайнятий.",
                "4.6": "Вже зареєстрований",
                "14.4": "Недійсний старий пароль",
                "5.2": "Абонемент недоступний у вибраному варіанті",
                "5.3": "У вас вже є активний абонемент",
                "14.9": "Електронна адреса не зареєстрована",
                "1.17": "Невірні дані"
            }

    }
}